<template>
  <div class="match-invite-page page">
    <!-- 主体 -->
    <Breadcrumb />
    <div class="detail-content">
      <div class="detail-title">{{ article.articleName || '' }}</div>
      <div class="detail-date">发布日期：{{ article.releaseTime || '' }}</div>
      <div class="detail-hr"></div>
      <div class="article-content" v-html="article.articleContent"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import { getArticleById, getSideArticle } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
import { fixMedia } from '@/utils/util'
export default {
  name: 'Policy',
  components: { Breadcrumb },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: {
        releaseTime: ''
      },
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      },
      sideArticle: {
        before: null,
        after: null
      },
      id: null,
      currentIndex: 2
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]
        if (this.tabList.list) {
          //拿下一级
          this.currentCategory = this.tabList.list[0]
        } else {
          this.currentCategory = this.tabList[0]
        }

        console.log('this.tabList', this.tabList)
      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
        this.article.articleContent = fixMedia(res.data.articleContent)
      })
    },
    // 查询上一篇文章和下一篇文章
    queryideArticle(id) {
      let params = {
        id: id,
        categoryCode: this.categoryId
      }
      getSideArticle(params).then((res) => {
        if (!res.data) return
        this.sideArticle = res.data
      })
    },
    handleSideArticle(id) {
      if (id == null) {
        return
      }
      let url =
        '/articleDetail?categoryId=' +
        this.categoryId +
        '&linkType=' +
        this.pageType +
        '&tabcode=' +
        this.tabcode +
        '&seccode=' +
        this.seccode +
        '&id=' +
        id
      window.location.href = url
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/singleImage' + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType)
      }
      if (item.linkType == 4) {
        console.log(item.linkType)
      }
      if (item.linkType == 5) {
        console.log(item.linkType)
      }
      this.$router.push({
        path: url
      })
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.id = this.$route.query?.id
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    if (this.tabcode == 103) {
      this.currentIndex = 2
    }
    if (this.tabcode == 104) {
      this.currentIndex = 3
    }
    this.seccode = this.$route.query?.seccode
    this.fetchData()
    this.getArticleData(this.id)
    this.queryideArticle(this.id)
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .detail-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 64px auto 120px;
    .side-content {
      display: flex;
      flex-direction: column;
      .side-flex {
        min-height: 22px;
        line-height: 22px;
        display: flex;
        flex-direction: row;
        font-size: 16px;
        .flex-title {
          color: #111;
          flex: 1;
        }
        .flex-title-active {
          color: #005bac;
          cursor: pointer;
        }
        .flex-text {
          color: 111;
        }
      }
      .side-flex:last-child {
        margin-top: 16px;
      }
    }
    .detail-area {
      background: #f9fafb;
      height: 38px;
      margin: 42px 0 10px;
    }
    .article-content {
      color: #111;
      font-size: 20px;
      line-height: 44px;
    }
    .detail-hr {
      border-top: 1px solid #e6e6e6;
      margin: 36px 0 42px;
    }
    .detail-date {
      text-align: center;
      margin-top: 24px;
      color: #5c5c5c;
      font-size: 16px;
      height: 22px;
      line-height: 22px;
    }
    .detail-title {
      line-height: 27px;
      color: #111;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .detail-content {
      width: 345px;
      margin: 20px auto 60px;
      .side-content {
        .side-flex {
          font-size: 13px;
        }
        .side-flex:last-child {
          margin-top: 10px;
        }
      }
      .detail-area {
        height: 19px;
        margin: 21px 0 10px;
      }
      .article-content {
        font-size: 14px;
        line-height: 22px;
        img {
          width: 100%;
        }
      }
      .detail-hr {
        margin: 18px 0 21px;
      }
      .detail-date {
        margin-top: 12px;
        font-size: 12px;
        line-height: 18px;
        height: 18px;
      }
      .detail-title {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
